// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.column-filter {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  border-radius: 6px;
  cursor: pointer;
}

.btn-cont {
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
}

.filter-btn {
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
  vertical-align: middle;
  background-color: var(--color-gray-14-light);
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  border: solid 1px var(--color-gray-12-light);
  border-radius: 3px;
}

.search-input-cont {
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
}

.search-input {
  width: 100%;
  padding: 4px;
  background-color: var(--color-white-light);
  /* Safari/Chrome, other WebKit */
  /* Firefox, other Gecko */
  box-sizing: border-box;
  /* Opera/IE 8+ */
  border-radius: 4px;
  border: solid 1px var(--color-black-light);
  text-align: center;
}

.search-input::-webkit-search-cancel-button {
  -webkit-filter: grayscale(100%) !important;
}

.options-list-cont {
  flex-grow: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: var(--color-white-light);
  border-radius: 4px;
  border: solid 1px var(--color-black-light);
  overflow-y: auto;
}

.option-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  padding: 4px;
}

.button-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 3px;
}

.apply-btn-cont,
.reset-btn-cont {
  flex-grow: 1;
}

.apply-btn {
  width: 100%;
  height: min-content;
  padding: 0.25rem;
  border-radius: 3px;
  border: solid 1px var(--color-black-light);
  font-size: 1rem;
  background-color: var(--color-green-light);
  color: var(--color-black-light);
}

.reset-btn {
  width: 100%;
  height: min-content;
  padding: 0.25rem;
  color: var(--color-black-light);
  background-color: var(--color-red-light);
  border-radius: 3px;
  border: solid 1px var(--color-black-light);
  font-size: 1rem;
}

.filter-btn-active {
  background-color: var(--color-blue-0-light);
  border: solid 1px var(--color-gray-8-light);
}

.popover::part(content) {
  --max-width: fit-content !important;
  border-radius: 8px !important;
  overflow: hidden !important;
  border: solid 1px var(--color-black-light);
  padding: 6px;
}

.filter-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.25rem;
  height: -moz-fit-content;
  height: fit-content;
  max-height: 17rem;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 12rem;
}

.filter {
  height: 0;
  width: 0;
  position: absolute;
  top: 4px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  background-color: var(--color-gray-14-light);
  border-radius: 6px;
  box-shadow: -1px 0px 5px -2px rgba(0, 0, 0, 0.3);
}

.integer-filter {
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: center;
  padding: 4px;
}
.integer-filter ion-select {
  height: 1.5rem;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: solid 1px var(--color-black-light);
  text-align: center;
}
.integer-filter ion-input {
  height: 1.5rem;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border: solid 1px var(--color-black-light);
  text-align: center;
}

.mat-mdc-row {
  height: -moz-fit-content;
  height: fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
  padding-top: 0.125rem;
}

.mat-mdc-cell {
  padding: 0 !important;
  height: -moz-fit-content !important;
  height: fit-content !important;
}

.checkbox-inline {
  float: right;
  height: 18px;
  width: 18px;
}

.reorder-enabled ion-reorder {
  cursor: move;
  opacity: 0.4;
}

.checkbox-inline:focus-visible {
  outline: none;
}

.sc-ion-label-md-h {
  font-size: 14px;
}

/* dark theme styles */
.column-filter.dark .filter-btn {
  color: var(--color-black-dark);
  background-color: var(--color-blue-1-light);
  border: solid 1px var(--color-gray-12-dark);
}
.column-filter.dark .filter-btn-active {
  background-color: var(--color-blue-0-dark);
  border: solid 1px var(--color-gray-8-dark);
}
.column-filter.dark .search-input {
  background-color: var(--color-white-dark);
  border: solid 1px var(--color-black-dark);
}
.column-filter.dark .options-list-cont {
  background-color: var(--color-white-dark);
  border: solid 1px var(--color-black-dark);
}
.column-filter.dark .apply-btn {
  color: var(--color-black-dark);
  background-color: var(--color-green-dark);
  border: solid 1px var(--color-black-dark);
}
.column-filter.dark .reset-btn {
  color: var(--color-black-dark);
  background-color: var(--color-red-dark);
  border: solid 1px var(--color-black-dark);
}
.column-filter.dark .filter {
  background-color: var(--color-gray-14-dark);
}
.column-filter.dark .integer-filter ion-select {
  border: solid 1px var(--color-black-dark);
}
.column-filter.dark .integer-filter ion-input {
  border: solid 1px var(--color-black-dark);
}

.datetime.dark {
  color: var(--color-black-light) !important;
  background-color: var(--color-gray-3-dark) !important;
}

.popover.dark {
  color: var(--color-black-dark) !important;
}
.popover.dark .search-input {
  color: var(--color-white-dark) !important;
  --placeholder-color: var(--color-white-dark) !important;
  background-color: var(--color-gray-3-dark) !important;
}
.popover.dark .options-list-cont {
  color: var(--color-white-dark) !important;
  background-color: var(--color-gray-3-dark) !important;
}

.popover.dark::part(content) {
  color: var(--color-black-dark) !important;
  background-color: var(--color-white-dark) !important;
  border: solid 1px var(--color-black-dark);
}`, "",{"version":3,"sources":["webpack://./src/app/components/column-filter/column-filter.component.scss","webpack://./../../../../../Ryan%20Ticer/source/repos/seacom3/ui/src/app/components/column-filter/column-filter.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EAEA,aAAA;EACA,sBAAA;EAEA,2BAAA;EACA,mBAAA;EAEA,WAAA;EACA,kBAAA;EACA,eAAA;ACFJ;;ADKA;EACI,wBAAA;EAAA,mBAAA;EACA,WAAA;ACFJ;;ADKA;EACI,wBAAA;EAAA,mBAAA;EACA,WAAA;EACA,sBAAA;EAEA,4CAAA;EAEA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,4CAAA;EACA,kBAAA;ACLJ;;ADQA;EACI,WAAA;EACA,wBAAA;EAAA,mBAAA;ACLJ;;ADQA;EACI,WAAA;EAEA,YAAA;EAEA,0CAAA;EAGA,gCAAA;EAEA,yBAAA;EACA,sBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,0CAAA;EAEA,kBAAA;ACVJ;;ADaA;EACI,0CAAA;ACVJ;;ADaA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EAEA,gBAAA;EAEA,0CAAA;EAEA,kBAAA;EACA,0CAAA;EAEA,gBAAA;ACdJ;;ADiBA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;ACdJ;;ADiBA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EAEA,QAAA;ACfJ;;ADkBA;;EAEI,YAAA;ACfJ;;ADkBA;EACI,WAAA;EACA,mBAAA;EAEA,gBAAA;EAEA,kBAAA;EACA,0CAAA;EAEA,eAAA;EAEA,0CAAA;EACA,+BAAA;ACnBJ;;ADsBA;EACI,WAAA;EACA,mBAAA;EAEA,gBAAA;EAEA,+BAAA;EACA,wCAAA;EAEA,kBAAA;EACA,0CAAA;EAEA,eAAA;ACvBJ;;AD0BA;EACI,2CAAA;EACA,2CAAA;ACvBJ;;AD0BA;EACI,mCAAA;EACA,6BAAA;EACA,2BAAA;EAEA,0CAAA;EAEA,YAAA;ACzBJ;;AD4BA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EAEA,wBAAA;EAAA,mBAAA;EACA,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;AC1BJ;;AD6BA;EACI,SAAA;EACA,QAAA;EAEA,kBAAA;EACA,QAAA;EAEA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EAEA,gBAAA;EAEA,4CAAA;EAEA,kBAAA;EAGA,gDAAA;AC/BJ;;ADkCA;EACI,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,mBAAA;EACA,YAAA;AC/BJ;ADiCI;EACI,cAAA;EAEA,2BAAA;EACA,8BAAA;EACA,0CAAA;EAEA,kBAAA;ACjCR;ADoCI;EACI,cAAA;EAEA,4BAAA;EACA,+BAAA;EACA,0CAAA;EAEA,kBAAA;ACpCR;;ADwCA;EACI,wBAAA;EAAA,mBAAA;EACA,4BAAA;EAAA,uBAAA;EACA,qBAAA;ACrCJ;;ADwCA;EACI,qBAAA;EACA,mCAAA;EAAA,8BAAA;ACrCJ;;ADwCA;EACI,YAAA;EACA,YAAA;EACA,WAAA;ACrCJ;;ADwCA;EACI,YAAA;EACA,YAAA;ACrCJ;;ADwCA;EACI,aAAA;ACrCJ;;ADwCA;EACI,eAAA;ACrCJ;;ADwCA,sBAAA;AAEI;EACI,8BAAA;EACA,2CAAA;EACA,2CAAA;ACtCR;ADyCI;EACI,0CAAA;EACA,0CAAA;ACvCR;AD0CI;EACI,yCAAA;EACA,yCAAA;ACxCR;AD2CI;EACI,yCAAA;EACA,yCAAA;ACzCR;AD4CI;EACI,8BAAA;EACA,yCAAA;EACA,yCAAA;AC1CR;AD6CI;EACI,8BAAA;EACA,uCAAA;EACA,yCAAA;AC3CR;AD8CI;EACI,2CAAA;AC5CR;ADgDQ;EACI,yCAAA;AC9CZ;ADiDQ;EACI,yCAAA;AC/CZ;;ADqDA;EACI,0CAAA;EACA,qDAAA;AClDJ;;ADqDA;EACI,yCAAA;AClDJ;ADoDI;EACI,yCAAA;EACA,uDAAA;EACA,qDAAA;AClDR;ADqDI;EACI,yCAAA;EACA,qDAAA;ACnDR;;ADuDA;EACI,yCAAA;EACA,oDAAA;EACA,yCAAA;ACpDJ","sourcesContent":[".column-filter {\r\n    position: relative;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n\r\n    width: 100%;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n}\r\n\r\n.btn-cont {\r\n    height: fit-content;\r\n    width: 100%;\r\n}\r\n\r\n.filter-btn {\r\n    height: fit-content;\r\n    width: 100%;\r\n    vertical-align: middle;\r\n\r\n    background-color: var(--color-gray-14-light);\r\n\r\n    font-size: 1rem;\r\n    font-weight: bold;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n\r\n    border: solid 1px var(--color-gray-12-light);\r\n    border-radius: 3px;\r\n}\r\n\r\n.search-input-cont {\r\n    width: 100%;\r\n    height: fit-content;\r\n}\r\n\r\n.search-input {\r\n    width: 100%;\r\n\r\n    padding: 4px;\r\n\r\n    background-color: var(--color-white-light);\r\n\r\n    -webkit-box-sizing: border-box;\r\n    /* Safari/Chrome, other WebKit */\r\n    -moz-box-sizing: border-box;\r\n    /* Firefox, other Gecko */\r\n    box-sizing: border-box;\r\n    /* Opera/IE 8+ */\r\n\r\n    border-radius: 4px;\r\n    border: solid 1px var(--color-black-light);\r\n\r\n    text-align: center;\r\n}\r\n\r\n.search-input::-webkit-search-cancel-button {\r\n    -webkit-filter: grayscale(100%) !important;\r\n}\r\n\r\n.options-list-cont {\r\n    flex-grow: 1;\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    overflow: hidden;\r\n\r\n    background-color: var(--color-white-light);\r\n\r\n    border-radius: 4px;\r\n    border: solid 1px var(--color-black-light);\r\n\r\n    overflow-y: auto;\r\n}\r\n\r\n.option-row {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    gap: 4px;\r\n    padding: 4px;\r\n}\r\n\r\n.button-row {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n\r\n    gap: 3px;\r\n}\r\n\r\n.apply-btn-cont,\r\n.reset-btn-cont {\r\n    flex-grow: 1;\r\n}\r\n\r\n.apply-btn {\r\n    width: 100%;\r\n    height: min-content;\r\n\r\n    padding: .25rem;\r\n\r\n    border-radius: 3px;\r\n    border: solid 1px var(--color-black-light);\r\n\r\n    font-size: 1rem;\r\n\r\n    background-color: var(--color-green-light);\r\n    color: var(--color-black-light);\r\n}\r\n\r\n.reset-btn {\r\n    width: 100%;\r\n    height: min-content;\r\n\r\n    padding: .25rem;\r\n\r\n    color: var(--color-black-light);\r\n    background-color: var(--color-red-light);\r\n\r\n    border-radius: 3px;\r\n    border: solid 1px var(--color-black-light);\r\n\r\n    font-size: 1rem;\r\n}\r\n\r\n.filter-btn-active {\r\n    background-color: var(--color-blue-0-light);\r\n    border: solid 1px var(--color-gray-8-light);\r\n}\r\n\r\n.popover::part(content) {\r\n    --max-width: fit-content !important;\r\n    border-radius: 8px !important;\r\n    overflow: hidden !important;\r\n\r\n    border: solid 1px var(--color-black-light);\r\n\r\n    padding: 6px;\r\n}\r\n\r\n.filter-cont {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    gap: .25rem;\r\n\r\n    height: fit-content;\r\n    max-height: 17rem;\r\n    width: fit-content;\r\n    max-width: 12rem;\r\n}\r\n\r\n.filter {\r\n    height: 0;\r\n    width: 0;\r\n\r\n    position: absolute;\r\n    top: 4px;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    gap: 4px;\r\n\r\n    overflow: hidden;\r\n\r\n    background-color: var(--color-gray-14-light);\r\n\r\n    border-radius: 6px;\r\n    -webkit-box-shadow: -1px 0px 5px -2px rgb(0 0 0 / 75%);\r\n    -moz-box-shadow: -1px 0px 5px -2px rgba(0, 0, 0, 0.75);\r\n    box-shadow: -1px 0px 5px -2px rgb(0 0 0 / 30%);\r\n}\r\n\r\n.integer-filter {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: stretch;\r\n    align-items: center;\r\n    padding: 4px;\r\n\r\n    ion-select {\r\n        height: 1.5rem;\r\n\r\n        border-top-left-radius: 4px;\r\n        border-bottom-left-radius: 4px;\r\n        border: solid 1px var(--color-black-light);\r\n\r\n        text-align: center;\r\n    }\r\n\r\n    ion-input {\r\n        height: 1.5rem;\r\n\r\n        border-top-right-radius: 4px;\r\n        border-bottom-right-radius: 4px;\r\n        border: solid 1px var(--color-black-light);\r\n\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n.mat-mdc-row {\r\n    height: fit-content;\r\n    max-height: fit-content;\r\n    padding-top: .125rem;\r\n}\r\n\r\n.mat-mdc-cell {\r\n    padding: 0 !important;\r\n    height: fit-content !important;\r\n}\r\n\r\n.checkbox-inline {\r\n    float: right;\r\n    height: 18px;\r\n    width: 18px;\r\n}\r\n\r\n.reorder-enabled ion-reorder {\r\n    cursor: move;\r\n    opacity: 0.4;\r\n}\r\n\r\n.checkbox-inline:focus-visible {\r\n    outline: none\r\n}\r\n\r\n.sc-ion-label-md-h {\r\n    font-size: 14px;\r\n}\r\n\r\n/* dark theme styles */\r\n.column-filter.dark {\r\n    .filter-btn {\r\n        color: var(--color-black-dark);\r\n        background-color: var(--color-blue-1-light);\r\n        border: solid 1px var(--color-gray-12-dark);\r\n    }\r\n\r\n    .filter-btn-active {\r\n        background-color: var(--color-blue-0-dark);\r\n        border: solid 1px var(--color-gray-8-dark);\r\n    }\r\n\r\n    .search-input {\r\n        background-color: var(--color-white-dark);\r\n        border: solid 1px var(--color-black-dark);\r\n    }\r\n\r\n    .options-list-cont {\r\n        background-color: var(--color-white-dark);\r\n        border: solid 1px var(--color-black-dark);\r\n    }\r\n\r\n    .apply-btn {\r\n        color: var(--color-black-dark);\r\n        background-color: var(--color-green-dark);\r\n        border: solid 1px var(--color-black-dark);\r\n    }\r\n\r\n    .reset-btn {\r\n        color: var(--color-black-dark);\r\n        background-color: var(--color-red-dark);\r\n        border: solid 1px var(--color-black-dark);\r\n    }\r\n\r\n    .filter {\r\n        background-color: var(--color-gray-14-dark);\r\n    }\r\n\r\n    .integer-filter {\r\n        ion-select {\r\n            border: solid 1px var(--color-black-dark);\r\n        }\r\n\r\n        ion-input {\r\n            border: solid 1px var(--color-black-dark);\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.datetime.dark {\r\n    color: var(--color-black-light) !important;\r\n    background-color: var(--color-gray-3-dark) !important;\r\n}\r\n\r\n.popover.dark {\r\n    color: var(--color-black-dark) !important;\r\n\r\n    .search-input {\r\n        color: var(--color-white-dark) !important;\r\n        --placeholder-color: var(--color-white-dark) !important;\r\n        background-color: var(--color-gray-3-dark) !important;\r\n    }\r\n\r\n    .options-list-cont {\r\n        color: var(--color-white-dark) !important;\r\n        background-color: var(--color-gray-3-dark) !important;\r\n    }\r\n}\r\n\r\n.popover.dark::part(content) {\r\n    color: var(--color-black-dark) !important;\r\n    background-color: var(--color-white-dark) !important;\r\n    border: solid 1px var(--color-black-dark);\r\n}\r\n",".column-filter {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.btn-cont {\n  height: fit-content;\n  width: 100%;\n}\n\n.filter-btn {\n  height: fit-content;\n  width: 100%;\n  vertical-align: middle;\n  background-color: var(--color-gray-14-light);\n  font-size: 1rem;\n  font-weight: bold;\n  text-align: center;\n  vertical-align: middle;\n  border: solid 1px var(--color-gray-12-light);\n  border-radius: 3px;\n}\n\n.search-input-cont {\n  width: 100%;\n  height: fit-content;\n}\n\n.search-input {\n  width: 100%;\n  padding: 4px;\n  background-color: var(--color-white-light);\n  -webkit-box-sizing: border-box;\n  /* Safari/Chrome, other WebKit */\n  -moz-box-sizing: border-box;\n  /* Firefox, other Gecko */\n  box-sizing: border-box;\n  /* Opera/IE 8+ */\n  border-radius: 4px;\n  border: solid 1px var(--color-black-light);\n  text-align: center;\n}\n\n.search-input::-webkit-search-cancel-button {\n  -webkit-filter: grayscale(100%) !important;\n}\n\n.options-list-cont {\n  flex-grow: 1;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background-color: var(--color-white-light);\n  border-radius: 4px;\n  border: solid 1px var(--color-black-light);\n  overflow-y: auto;\n}\n\n.option-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 4px;\n  padding: 4px;\n}\n\n.button-row {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 3px;\n}\n\n.apply-btn-cont,\n.reset-btn-cont {\n  flex-grow: 1;\n}\n\n.apply-btn {\n  width: 100%;\n  height: min-content;\n  padding: 0.25rem;\n  border-radius: 3px;\n  border: solid 1px var(--color-black-light);\n  font-size: 1rem;\n  background-color: var(--color-green-light);\n  color: var(--color-black-light);\n}\n\n.reset-btn {\n  width: 100%;\n  height: min-content;\n  padding: 0.25rem;\n  color: var(--color-black-light);\n  background-color: var(--color-red-light);\n  border-radius: 3px;\n  border: solid 1px var(--color-black-light);\n  font-size: 1rem;\n}\n\n.filter-btn-active {\n  background-color: var(--color-blue-0-light);\n  border: solid 1px var(--color-gray-8-light);\n}\n\n.popover::part(content) {\n  --max-width: fit-content !important;\n  border-radius: 8px !important;\n  overflow: hidden !important;\n  border: solid 1px var(--color-black-light);\n  padding: 6px;\n}\n\n.filter-cont {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.25rem;\n  height: fit-content;\n  max-height: 17rem;\n  width: fit-content;\n  max-width: 12rem;\n}\n\n.filter {\n  height: 0;\n  width: 0;\n  position: absolute;\n  top: 4px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 4px;\n  overflow: hidden;\n  background-color: var(--color-gray-14-light);\n  border-radius: 6px;\n  -webkit-box-shadow: -1px 0px 5px -2px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: -1px 0px 5px -2px rgba(0, 0, 0, 0.75);\n  box-shadow: -1px 0px 5px -2px rgba(0, 0, 0, 0.3);\n}\n\n.integer-filter {\n  display: flex;\n  flex-direction: row;\n  justify-content: stretch;\n  align-items: center;\n  padding: 4px;\n}\n.integer-filter ion-select {\n  height: 1.5rem;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border: solid 1px var(--color-black-light);\n  text-align: center;\n}\n.integer-filter ion-input {\n  height: 1.5rem;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border: solid 1px var(--color-black-light);\n  text-align: center;\n}\n\n.mat-mdc-row {\n  height: fit-content;\n  max-height: fit-content;\n  padding-top: 0.125rem;\n}\n\n.mat-mdc-cell {\n  padding: 0 !important;\n  height: fit-content !important;\n}\n\n.checkbox-inline {\n  float: right;\n  height: 18px;\n  width: 18px;\n}\n\n.reorder-enabled ion-reorder {\n  cursor: move;\n  opacity: 0.4;\n}\n\n.checkbox-inline:focus-visible {\n  outline: none;\n}\n\n.sc-ion-label-md-h {\n  font-size: 14px;\n}\n\n/* dark theme styles */\n.column-filter.dark .filter-btn {\n  color: var(--color-black-dark);\n  background-color: var(--color-blue-1-light);\n  border: solid 1px var(--color-gray-12-dark);\n}\n.column-filter.dark .filter-btn-active {\n  background-color: var(--color-blue-0-dark);\n  border: solid 1px var(--color-gray-8-dark);\n}\n.column-filter.dark .search-input {\n  background-color: var(--color-white-dark);\n  border: solid 1px var(--color-black-dark);\n}\n.column-filter.dark .options-list-cont {\n  background-color: var(--color-white-dark);\n  border: solid 1px var(--color-black-dark);\n}\n.column-filter.dark .apply-btn {\n  color: var(--color-black-dark);\n  background-color: var(--color-green-dark);\n  border: solid 1px var(--color-black-dark);\n}\n.column-filter.dark .reset-btn {\n  color: var(--color-black-dark);\n  background-color: var(--color-red-dark);\n  border: solid 1px var(--color-black-dark);\n}\n.column-filter.dark .filter {\n  background-color: var(--color-gray-14-dark);\n}\n.column-filter.dark .integer-filter ion-select {\n  border: solid 1px var(--color-black-dark);\n}\n.column-filter.dark .integer-filter ion-input {\n  border: solid 1px var(--color-black-dark);\n}\n\n.datetime.dark {\n  color: var(--color-black-light) !important;\n  background-color: var(--color-gray-3-dark) !important;\n}\n\n.popover.dark {\n  color: var(--color-black-dark) !important;\n}\n.popover.dark .search-input {\n  color: var(--color-white-dark) !important;\n  --placeholder-color: var(--color-white-dark) !important;\n  background-color: var(--color-gray-3-dark) !important;\n}\n.popover.dark .options-list-cont {\n  color: var(--color-white-dark) !important;\n  background-color: var(--color-gray-3-dark) !important;\n}\n\n.popover.dark::part(content) {\n  color: var(--color-black-dark) !important;\n  background-color: var(--color-white-dark) !important;\n  border: solid 1px var(--color-black-dark);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
